export default "__VITE_ASSET__iUiepjqn__"